import React from "react";
import { View, StyleSheet, Text, TouchableOpacity, Platform } from "react-native";

import ManaButton from "../common/ManaButton";
import NewElementIcon from "../common/ActionsMenuButton/icons/NewElementIcon";
import AppMessages from "../../../config/AppMessages";
import AppTheme from "../AppTheme";

export default function NoResultsFound({
  message = AppMessages.EditRoutineNoResultsMessage,
  buttons = [],
}) {
  return (
    <View style={styles.container}>
      <View style={{ marginTop: 80 }}>
        <NewElementIcon width={100} height={100} />
      </View>

      <Text style={styles.text}>{message}</Text>

      <View>
        {buttons.map((b, index) => (
          <ManaButton
            key={index}
            isMainButton
            onPress={b.action}
            styleText={styles.buttonText}
            style={styles.button}
            text={b.text}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginTop: 24,
    marginBottom: 24,
    maxWidth: "90%",
  },
  button: {
    width: 218,
    height: 40,
    marginBottom: 10,
  },
  buttonText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
  },
});
